import React from 'react';
import { render } from 'react-dom';
import { localStore } from 'utils/storage';
import { STORAGE_KEYS } from 'constants/storage';
import GdprContainer from 'tradera-components/alerts/gdpr/gpdr-container';
import { CookieNotification } from 'tradera-components/alerts/cookies';
import GdprSiteFooterComponent from './gdpr-site-footer-component';

let _gdprOpenSettingsAction = null;

const bootLegacyCookieAlert = () => {
    const domNode = document.querySelector(
        '[data-component-cookie-notification]'
    );
    // Only load this if it ain't already dismissed
    if (localStore && !localStore.getItem(STORAGE_KEYS.COOKIE_NOTIFICATION)) {
        if (domNode) {
            CookieNotification(domNode);
        }
    }
};

const registerOpenGdprSettingsAction = openAction =>
    (_gdprOpenSettingsAction = openAction);

const openGdprSettings = () =>
    _gdprOpenSettingsAction ? _gdprOpenSettingsAction() : null;

const GdprMount = featureSwitches => {
    // use old cookie alert?
    if (!featureSwitches['gdpr-consent-popup']) {
        bootLegacyCookieAlert();
        return;
    }

    const domNode = document.querySelector(
        '[data-component-cookie-notification]'
    );
    if (domNode) {
        render(
            <GdprContainer
                registerOpenGdprSettingsAction={registerOpenGdprSettingsAction}
            />,
            domNode
        );
    }
    const footerActionElement = document.querySelector(
        '[data-gdpr-footer-action]'
    );
    if (footerActionElement) {
        render(
            <GdprSiteFooterComponent action={openGdprSettings} />,
            footerActionElement
        );
    }
};

export default GdprMount;
